var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vector",
    _vm._b(
      {
        attrs: {
          "show-viewbox": false,
          id: "dogsocean-scene" + _vm._uid,
          overflow: _vm.overflow
        }
      },
      "vector",
      _vm.$props,
      false
    ),
    [
      _c("clock", {
        attrs: { fps: 15, keyframe: _vm.keyframe, start: 0, end: 3275 },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(clock) {
              return [
                _c(
                  "g",
                  [
                    _c("delay", {
                      attrs: { keyframe: _vm.keyframe, start: 0 },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(reset) {
                              return [
                                _c(
                                  "sky",
                                  { attrs: { keyframe: reset.keyframe } },
                                  [
                                    _c(
                                      "g",
                                      [
                                        _c("delay", {
                                          attrs: {
                                            keyframe: _vm.keyframe,
                                            start: 1100
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(reset) {
                                                  return [
                                                    _c("coast", {
                                                      attrs: {
                                                        keyframe:
                                                          reset.keyframe,
                                                        transform:
                                                          "translate(0 1105)"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._t("default")
                                  ],
                                  2
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _c("delay", {
                      attrs: { keyframe: _vm.keyframe, start: 1100 },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(octopus) {
                              return [
                                _c(
                                  "g",
                                  [
                                    _c(
                                      "underwater",
                                      {
                                        attrs: {
                                          "show-viewbox": false,
                                          y: 1595,
                                          color: "#42A7B0",
                                          align: "topleft",
                                          position: _vm.underwaterPosition,
                                          "octopus-keyframe": octopus.keyframe,
                                          keyframe: clock.keyframe
                                        }
                                      },
                                      [_vm._t("default")],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _c("do-a-barrel-roll", {
                      attrs: { keyframe: _vm.keyframe },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(barrel) {
                              return [
                                _c(
                                  "balloon",
                                  _vm._b(
                                    {
                                      attrs: {
                                        x: -225,
                                        y: 500,
                                        sx: 0.5,
                                        sy: 0.5
                                      }
                                    },
                                    "balloon",
                                    barrel,
                                    false
                                  ),
                                  [
                                    _vm.keyframe < 2267
                                      ? _c("pig", {
                                          attrs: {
                                            width: "90",
                                            height: "80",
                                            align: "topleft",
                                            fit: false,
                                            x: 75,
                                            y: 450,
                                            position: _vm.pigPos
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }